import { createContext } from 'react';

import type { MultiMeterBarChartConsumerConfig } from '../types/multi-meter-bar-chart-config.js';

/**
 * @internal
 */
export const MultiMeterBarChartConfigContext = createContext<
  MultiMeterBarChartConsumerConfig | string
>({});

/**
 * Provider for the multi meter bar chart configuration that can be shared across charts
 * @public
 */
export const MultiMeterBarChartConfig =
  MultiMeterBarChartConfigContext.Provider;
